import {SmileOutlined} from '@ant-design/icons';
import {
    Button, Col, Empty, message, Pagination, Result, Row, Select, Spin, Table, Tag, Tooltip
} from 'antd';
import axios from "axios";
import {Component} from 'react';
import cookie from "react-cookies";
import {connect} from "react-redux";
import '../asset/style/custom_antd_table_style.css';
import FilterCompClia from "../component/case/filter_clia";
import {makeMenuVisible} from "../redux_actions/context.menu.action";
import {changePage, updateUrlStateInReducerClia} from '../redux_actions/search.case.action';
import {openInNewTabType} from '../utils/const';

import querystring from "query-string";
import {getCaseIdPlaceholder} from 'utils/org_utils';
import {get, post} from "../helper/request";
import {getStateAwareUrl, isTrue, openEndPoint} from "../utils/utils";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";
import {AuthHeader} from "../configs/auth.token";
import {CssBaseline, IconButton as MuiIconButton, IconButton, ThemeProvider} from "@mui/material";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import {addCasesToShare} from "../redux_actions/shareManager.action";
import ShareModal from "../component/utils/shareModal";
import {morphleTheme1} from "../component/gammaviewer/themes";
import {getAssignedNamesComponent} from "../component/case/case_utils";


const pageSize = 15;

class CliaView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowKeys: [],
            search: this.props.urlState.search,
            initializationDone: false,
            case_status: -1,
            selected_users: [],
            validationIds: [],
            selectedValidation: '',
            assignedValidations: {},
            validatonSummary: [],
            currentValidationId: this.props.validationId,
            view_type: this.props.type,
            validationName: '',
        }

        this.is_clia_staff = hasPermissions([aclPermissions.clia_staff])
        this.assignCasePerm = hasPermissions([aclPermissions.assign_case])
        this.props.dispatch(updateUrlStateInReducerClia(this.props.urlState, this.props.type));
    }

    componentWillMount() {
        this.getValidationData();
    }

    getValidationData = (id) => {
        let url = `/api/get_validation_data/?id=${this.props.validationId}`;
        get(url)
            .then(data => {
                this.setState({
                    validationName: data['name'],
                })
            })
    }

    getCases = (cases) => {
        let newData = []
        Object.keys(cases).sort(function (a, b) {
            return cases[a].displayOrder - cases[b].displayOrder;
        }).forEach((key) => {
            let curr = cases[key];
            curr.key = curr.id;
            curr.case = this.getCaseDesign(curr);
            curr.type = openInNewTabType.CASE;
            newData.push(curr);
        });
        return newData;
    }

    getCaseDesign = (caseInfo) => {

        const isArchived = isTrue(caseInfo.archive_status)

        const dateElement = (
            caseInfo.unread ?
                <b>{caseInfo.date}</b> :
                <span>{caseInfo.date}</span>
        )

        const isLongCaseID = caseInfo.case_id.length > 15;
        const caseIdElem = (
            caseInfo.unread ?
                <b>{isLongCaseID ? `${caseInfo.case_id.slice(0, 15)}...` : caseInfo.case_id}</b> :
                <span>{isLongCaseID ? `${caseInfo.case_id.slice(0, 15)}...` : caseInfo.case_id}</span>
        );
        const finalCaseIdElem = isLongCaseID ?
            <Tooltip title={caseInfo.case_id} key={caseInfo.case_id}>{caseIdElem}</Tooltip> : caseIdElem;

        const isLongName = caseInfo.patient_name && caseInfo.patient_name.length > 25;
        const nameElem = (
            caseInfo.unread ?
                <b>{isLongName ? `${caseInfo.patient_name.slice(0, 25)}...` : caseInfo.patient_name}</b> :
                <span>{isLongName ? `${caseInfo.patient_name.slice(0, 25)}...` : caseInfo.patient_name}</span>
        );
        const finalNameElem = isLongName ?
            <Tooltip title={caseInfo.patient_name} key={caseInfo.patient_name}>{nameElem}</Tooltip> : nameElem;

        const isLongStatus = caseInfo.validation_status?.length > 35;
        const statusElem = [
            <Tag onClick={(event) => event.stopPropagation()} color={isArchived ? "lightgray" : null}>{isArchived ? "Archived" : "Inbox"}</Tag>,
            caseInfo.validation_status ? <Tag key={caseInfo.case_id} color={isArchived ? null : "purple"} onClick={(event) => event.stopPropagation()}>
                {isLongStatus ? `${caseInfo.validation_status?.slice(0, 35)}...` : caseInfo.validation_status}
            </Tag> : null
        ];
        const finalStatusElem = isLongStatus ?
            <Tooltip title={caseInfo.case_status} key={caseInfo.case_status}>{statusElem}</Tooltip> : statusElem;
        const priorityElem = caseInfo.priority

        const assigned_names = getAssignedNamesComponent(caseInfo, isArchived);

        const slide_count = caseInfo.unread ? <b>{caseInfo.slide_count}</b> : <span>{caseInfo.slide_count}</span>

        const assignUserButton = this.assignCasePerm ? <Tooltip title={"Assign To Users"}><IconButton><AssignmentIndOutlinedIcon/></IconButton></Tooltip> : null

        return <Row style={{display: 'flex', alignItems: 'center'}}>
            <Col span={2}>
                {dateElement}
            </Col>
            <Col span={4}>
                {finalCaseIdElem}
            </Col>
            <Col span={4}>
                {finalNameElem}
            </Col>
            <Col span={4}>
                {finalStatusElem}
            </Col>
            <Col span={2}>
                {priorityElem}
            </Col>
            <Col span={5}>
                {assigned_names}
            </Col>
            <Col span={1}>
                {slide_count}
            </Col>
            <Col span={1} style={{display: 'flex', justifyContent: 'flex-end'}} onClick={(e) => {
                e.stopPropagation();
                this.caseRefreshProps = [caseInfo];
                this.props.dispatch(addCasesToShare(caseInfo.id))
            }}>
                {assignUserButton}
            </Col>
        </Row>
    }

    initializeSearch = () => {
        if (!this.state.initializationDone && ((this.props.urlState || {}).search || {}).length > 0) {
            this.setState({
                search: this.props.urlState.search, initializationDone: true,
            })
        }
    }

    assignMultipleCases = (e) => {
        e.stopPropagation();
        let case_ids = []
        let cases = []
        this.state.selectedRowKeys.forEach((value) => {
            case_ids.push(this.props.allCases[value].id);
            cases.push(this.props.allCases[value]);
        });
        this.caseRefreshProps = cases;
        this.props.dispatch(addCasesToShare(case_ids))
    }

    getRowActionsIfAtleastOneRowSelected = () => {
        return this.state.selectedRowKeys.length > 0 ? <Row>
            {this.props.type === 'assigned' ? <Col span={6}>
                <Button onClick={this.handleChangeUnassignValidation} type="primary">
                    {`Remove from ${this.state.validationName}`}
                </Button>
            </Col> : <Col span={6}>
                <Button onClick={this.handleChangeAssignValidation} type="primary">
                    {`Add to ${this.state.validationName}`}
                </Button>
            </Col>}

            {this.assignCasePerm && <Tooltip placement="top" title={"Assign to Users"}>
                <MuiIconButton color={"primary"} size={"small"}
                               onClick={this.assignMultipleCases}>
                    <AssignmentIndOutlinedIcon/>
                </MuiIconButton>
            </Tooltip>}
        </Row> : <FilterCompClia/>
    }

    handleChangeAssignValidation = () => {
        let selectedRowKeys = this.state.selectedRowKeys;
        let selectedValidation = this.props.validationId;
        let url = "/api/assign_validation/"
        post(url, querystring.stringify({selected_cases: selectedRowKeys, validation: selectedValidation}))
            .then(response => {
                message.success("Case/Cases Successfully Updated");
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
    }

    handleChangeUnassignValidation = () => {
        let selectedRowKeys = this.state.selectedRowKeys;
        let selectedValidation = this.props.validationId;
        let url = "/api/unassign_validation/"
        post(url, querystring.stringify({selected_cases: selectedRowKeys, validation: selectedValidation}))
            .then(response => {
                message.success("Case/Cases Successfully Updated");
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
    }

    getPaginationDiv = () => {
        return <Pagination
            total={this.props.total}
            showTotal={(total, range) => this.isMobile ? `` : `Showing ${range[0]}-${range[1]} out of ${total} total cases`}
            current={this.props.urlState.page}
            pageSize={pageSize}
            defaultCurrent={1}
            onChange={this.updatePageNew}
            size="small"
            className="pagination-mp"
        />
    }

    updatePageNew = (pageNumber) => {
        openEndPoint(`/clia_validation/${this.props.validationId}?&page=` + pageNumber, false, true);
        this.props.dispatch(changePage(pageNumber, this.props.urlState));
    }

    linkCliaCase = (id) => {
        openEndPoint("/clia_case/" + id);
    }

    openDashboard = () => {
        openEndPoint("/");
    }

    getOSDetails = () => {
        let OSVersion = navigator.appVersion
        let os = 'Not Supported'
        if (OSVersion.indexOf("Win") !== -1) {
            os = "Windows"
        } else if (OSVersion.indexOf("Mac") !== -1) {
            os = "Mac"
        } else if (OSVersion.indexOf("Linux") !== -1) {
            os = "Linux"
        }
        return os
    }

    downloadCLIAApp = () => {
        let appName = 'morphle-clia.deb';
        let os = this.getOSDetails();
        let url = `/api/download_app/?os=${os}`; // `http://0.0.0.0:8002/api/download_app/?os=${os}`
        if (os === 'Windows') {
            appName = 'morphle-clia.exe'
        } else if (os === 'Mac') {
            appName = 'morphle-clia.app'
        } else if (os === 'Linux') {
            appName = 'morphle-clia.deb'
        }
        axios.get(getStateAwareUrl(url), {
            responseType: 'blob', headers: {Authorization: AuthHeader()}
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', appName); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }

    isValidUUID = (uuid) => {
        let token = "" + uuid
        token = token.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
        return token !== null;

    }

    render() {
        this.initializeSearch();
        let data = this.getCases(this.props.allCases);
        let os = this.getOSDetails();
        let columns = [{
            title: () => {
                return <div>
                    <Row>
                        <Col span={2}>
                            <b>DATE</b>
                        </Col>
                        <Col span={4}>
                            <b>{getCaseIdPlaceholder()}</b>
                        </Col>
                        <Col span={4}>
                            <b>PATIENT'S NAME</b>
                        </Col>
                        <Col span={4}>
                            <b>STATUS</b>
                        </Col>
                        <Col span={2}>
                            <b>PRIORITY</b>
                        </Col>
                        <Col span={5}>
                            <b>ASSIGNED USERS</b>
                        </Col>
                        <Col span={1}>
                            <b>SLIDES</b>
                        </Col>
                        <Col span={2}>

                        </Col>
                    </Row>
                </div>
            }, dataIndex: "case", key: "case",
        }]

        const onRow = (record, rowIndex) => {
            return {
                onClick: event => {
                    this.linkCliaCase(record.id);
                }, onContextMenu: (event) => {
                    event.preventDefault();
                    this.props.dispatch(makeMenuVisible({
                        visible: true, x: event.clientX, y: event.clientY, record: record, height: this.props.height
                    }));
                }
            };
        }

        let rowActions = [<Row className="row-actions">
            {this.getRowActionsIfAtleastOneRowSelected()}
        </Row>];

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            }, selectedRowKeys: this.state.selectedRowKeys, columnWidth: '10px',

        };


        if (cookie.loadAll().isMobile === 'true') {
            return (<div>
                <Result
                    status="warning"
                    title="CLIA doesnt support mobile devices! Switch to PC!"
                    extra={<Button type="primary" key="console" onClick={this.openDashboard}>
                        Dashboard
                    </Button>}
                />
            </div>)
        }

        if (os === 'Not Supported') {
            return (<div>
                <Result
                    status="warning"
                    title="CLIA only supports Windows/Linux/MacOS!"
                    extra={<Button type="primary" key="console" onClick={this.openDashboard}>
                        Dashboard
                    </Button>}
                />
            </div>)
        }
        os = this.getOSDetails();

        let steps;
        if (os === "Windows") {
            steps = <div>
                <h3>Installation on Windows:</h3>
                <ol style={{display: 'inline-block', textAlign: 'left'}}>
                    <li> Make sure you are using chrome browser</li>
                    <li> Download the App</li>
                    <li> Double Click on downloaded MorphleClia.exe file to run it</li>
                </ol>
            </div>
        } else if (os === "Mac") {
            steps = <div>
                <h3>Installation on MAC:</h3>
                <ul style={{display: 'inline-block', textAlign: 'left'}}>
                    <li>Make sure you are using chrome browser</li>
                    <li>Download the App</li>
                    <li>Double Click on downloaded MorphleClia.app file to run it</li>
                </ul>
            </div>
        } else if (os === "Linux") {
            steps = <div style={{textAlign: 'center'}}>
                <h3>Installation on Linux:</h3>
                <ol style={{display: 'inline-block', textAlign: 'left'}}>
                    <li>Make sure you are using chrome browser</li>
                    <li>Download the App</li>
                    <li>Double Click on downloaded MorphleClia.deb file to install it</li>
                    <li>After installation go to the apps and run MorphleClia</li>
                </ol>
            </div>
        }

        if ((!isTrue(cookie.loadAll().screen_supported) || !this.isValidUUID(cookie.loadAll().screen_supported)) && isTrue(cookie.loadAll().clia_screen_check)) {
            return (<div>
                <Result
                    icon={<SmileOutlined/>}
                    title="CLIA : Digital Pathology Validation"
                    extra={<div>
                        <p style={{fontSize: '20px'}}>Your organisation allows only set number of Digital displays
                            (Monitors) for CLIA. <br></br>To verify compatibility please download the app and follow
                            the mentioned steps to RUN it.</p>
                        <p style={{fontSize: '20px'}}>If already downloaded just follow the steps to RUN it.</p>
                        <Button type="primary" onClick={this.downloadCLIAApp}>Download</Button>
                    </div>}
                />
                <div style={{fontSize: '20px'}}>

                    {steps}
                </div>
            </div>)
        }

        return (<div className={"full-parent"}><Spin tip="Loading..." spinning={this.props.isFetching} delay={500}
                                                     wrapperClassName={'full-parent'}>
            {this.props.isFetching === true ? <div></div> : <Row>
                <Col span={24} offset={0}>
                    {rowActions}
                    <Row>
                        <Table
                            className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                            rowClassName={(record, index) => (record.unread ? 'slide-table-rows custom-hover-table-box unread' : 'slide-table-rows custom-hover-table-box read')}
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                            onRow={onRow}
                            locale={{emptyText: (<Empty description="No Cases Found"/>)}}
                            rowSelection={this.is_clia_staff ? rowSelection : null}
                            size="small"
                        />
                    </Row>
                    <Row>
                        {this.getPaginationDiv()}
                    </Row>
                </Col>
            </Row>}
        </Spin>
            {this.props.caseModalOpen ? <ThemeProvider theme={morphleTheme1}>
                <CssBaseline/><ShareModal type={openInNewTabType.CASE} assign={true}
                                          caseRefreshProps={this.caseRefreshProps}/></ThemeProvider> : null}
        </div>);
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        allCases: state.casesReducer,
        allCaseStatus: state.caseStatusReducer.case_status,
        allUsers: state.caseStatusReducer.users,
        numPages: state.caseStatusReducer.numPages,
        pageNumber: state.caseStatusReducer.pageNumber,
        total: state.caseStatusReducer.total,
        urlState: state.searchCaseReducer,
        isFetching: state.searchCaseReducer.isFetching,
        caseModalOpen: state.shareManagerReducer.caseModalOpen,
    };
};

export default connect(mapStateToProps)(CliaView);
